module.exports = "/assets/data/7ff1b1ed269076585a471d308df66df9-BS36.data.json";